import { combineReducers } from 'redux';
import pbxsReducer from '../features/pbxs/pbxs.slice';
import ulareReducer from '../features/ulare/ulare.slice';
import ordersReducer from '../features/orders/orders.slice';
import enclosuresReducer from '../features/enclosures/enclosures.slice';
import portingsReducer from '../features/porting/porting.slice';
import inventoryReducer from '../features/inventory/inventory.slice';
import dataPlansReducer from '../features/dataPlans/dataPlans.slice';
import countriesReducer from '../features/countries/countries.slice';
import cellTowersReducer from '../features/cellTowers/cellTowers.slice';
import cellTowerReportsReducer from '../features/cellTowerReports/cellTowerReports.slice';
import smsLoggerReducer from '../features/smsLogger/smsLogger.slice';
import alarmsReducer from '../features/alarm/alarm.slice';
import notificationsReducer from '../features/notifications/notifications.slice';
import externalSystemsReducer from '../features/externalSystems/externalSystems.slice';
import cdrsReducer from '../features/cdrs/cdrs.slice';
import ticketsReducer from '../features/tickets/tickets.slice';
import addressesReducer from '../features/addresses/addresses.slice';
import logsReducer from '../features/logs/logs.slice';
import secureAlarmReducer from '../features/secureAlarm/secureAlarm.slice';
import warehousesReducer from '../features/warehouses/warehouses.slice';
import batteriesReducer from '../features/batteries/batteries.slice';
import brandsReducer from '../features/brands/brands.slice';
import modelsReducer from '../features/models/model.slice';
import dialersReducer from '../features/dialers/dialers.slice';
import powerCyclesReducer from '../features/powerCycles/powerCycles.slice';
import didsReducer from '../features/dids/dids.slice';
import contactIDMessagesReducer from '../features/contactIDMessages/contactIDMessages.slice';
import organizationsReducer from '../features/organizations/organizations.slice';
import didManagerReducer from '../features/didManager/didManager.slice';
import tcServicesReducer from '../features/tcServices/tcServices.slice';
import tcServiceContractsReducer from '../features/tcServiceContracts/tcServiceContracts.slice';
import tcServiceOrdersReducer from '../features/tcServiceOrders/tcServiceOrders.slice';
import routersReducer from '../features/routers/routers.slice';
import sharedReducer from '../features/shared/shared.slice';
import authReducer from '../features/auth/auth.slice';
import equipmentGroupsReducer from '../features/equipmentGroups/equipmentGroups.slice';
import locationsReducer from '../features/locations/locations.slice';
import atasReducer from '../features/atas/atas.slice';
import usersReducer from '../features/users/users.slice';
import utilsReducer from '../features/utils/utils.slice';
import tcSimsReducer from '../features/tcSims/tcSims.slice';
import releaseNotesReducer from '../features/releaseNotes/releaseNotes.slice';
import releaseNotificationsReducer from '../features/releaseNotifications/releaseNotifications.slice';
import contactsReducer from '../features/contacts/contacts.slice';
import salesReportsReducer from '../features/salesReports/salesReport.slice';
import orderReportsReducer from '../features/orderReport/orderReport.slice';
import deviceReportReducer from '../features/deviceSalesReport/deviceSalesReport.slice';
import accessAndVisibilityReducer from '../features/accessAndVisibility/accessAndVisibility.slice';
import cdrsSettingsReducer from '../features/cdrsSettings/cdrsSettings.slice';
import potscastReducer from '../features/potscast/potscast.slice';
import serviceCallsReducer from '../features/serviceCalls/serviceCalls.slice';
import SupportAdminPanelReducer from '../features/supportAdminPanel/SupportAdminPanel.slice';
import megaswitchReducer from '../features/megaswitch/megaswitch.slice';
import telcobillPackageSettingsReducer from '../features/telcobillPackageSettings/telcobillPackageSettings.slice';
import wholesaleBillingSettingsReducer from '../features/wholesaleBillingSettings/wholesaleBillingSettings.slice';
import billProfilesReducer from '../features/billProfiles/billProfiles.slice';
import leadsReducer from '../features/leads/leads.slice';
import fiberReducer from '../features/fiber/fiber.slice';
import starlinkReducer from '../features/starlink/starlink.slice';
import deviceDetailsReducer from '../features/deviceDetails/deviceDetails.slice';
import fullServiceInstallationReportReducer from '../features/fullServiceInstallationReport/fullServiceInstallationReport.slice';
import serviceCallReportReducer from '../features/serviceCallReport/serviceCallReport.slice';
import permissionsReducer from '../features/permissions/permissions.slice';
import csrpReducer from '../features/csrp/csrp.slice';
import authorizationReducer from '../features/authorization/authorization.slice';
import priDevicesReducer from '../features/priDevices/priDevices.slice';
import smartphonesReducer from '../features/smartphones/smartphones.slice';
import pbxExtensionsReducer from '../features/pbxExtensions/pbxExtensions.slice';

const reducers = combineReducers({
  contactsReducer,
  pbxsReducer,
  ticketsReducer,
  ordersReducer,
  enclosuresReducer,
  portingsReducer,
  inventoryReducer,
  dataPlansReducer,
  countriesReducer,
  cellTowersReducer,
  cellTowerReportsReducer,
  alarmsReducer,
  smsLoggerReducer,
  tcSimsReducer,
  utilsReducer,
  usersReducer,
  equipmentGroupsReducer,
  externalSystemsReducer,
  organizationsReducer,
  locationsReducer,
  didsReducer,
  notificationsReducer,
  cdrsReducer,
  cdrsSettingsReducer,
  addressesReducer,
  logsReducer,
  secureAlarmReducer,
  warehousesReducer,
  batteriesReducer,
  brandsReducer,
  modelsReducer,
  dialersReducer,
  powerCyclesReducer,
  contactIDMessagesReducer,
  didManagerReducer,
  tcServicesReducer,
  tcServiceContractsReducer,
  tcServiceOrdersReducer,
  routersReducer,
  sharedReducer,
  atasReducer,
  authReducer,
  releaseNotesReducer,
  releaseNotificationsReducer,
  salesReportsReducer,
  orderReportsReducer,
  deviceReportReducer,
  accessAndVisibilityReducer,
  potscastReducer,
  serviceCallsReducer,
  telcobillPackageSettingsReducer,
  wholesaleBillingSettingsReducer,
  SupportAdminPanelReducer,
  megaswitchReducer,
  billProfilesReducer,
  leadsReducer,
  deviceDetailsReducer,
  ulareReducer,
  fullServiceInstallationReportReducer,
  serviceCallReportReducer,
  permissionsReducer,
  csrpReducer,
  fiberReducer,
  starlinkReducer,
  authorizationReducer,
  priDevicesReducer,
  pbxExtensionsReducer,
  smartphonesReducer,
});

export default reducers;
export type RootReducerState = ReturnType<typeof reducers>;
